<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2 sm:px-3">
    <header class="min-w-0">
      <h1 class="font-display text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">Paramètres</h1>
      <p class="text-gray-500 mt-1">Gérez vos préférences de sécurité et de notifications.</p>
    </header>

    <!-- Abonnement -->
    <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-4 shadow-sm">
      <div class="flex items-center gap-2">
        <span class="material-symbols-outlined text-secondary">workspace_premium</span>
        <h2 class="font-semibold text-gray-900">Passer au compte Pro</h2>
        <span class="rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-800">À venir</span>
      </div>
      <div class="rounded-lg border border-gray-100 bg-gray-50 px-4 py-3">
        <p class="text-sm text-gray-700">
          Le compte Pro vous permettra de gérer plusieurs entreprises et d'automatiser la récupération de vos documents.
        </p>
        <p class="text-xs text-gray-500 mt-2">
          Vous utilisez actuellement le plan gratuit (jusqu'à 5 entreprises, informations fiscales uniquement).
        </p>
      </div>
      <button
        type="button"
        disabled
        class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-400 cursor-not-allowed bg-gray-50"
      >
        Passer au compte Pro — bientôt disponible
      </button>
    </article>

    @if (loading()) {
      <article class="rounded-xl border border-gray-200 bg-white p-5 text-sm text-gray-500">Chargement...</article>
    } @else if (settings(); as s) {
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-5 shadow-sm">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">apartment</span>
          <h2 class="font-semibold text-gray-900">Profil utilisateur</h2>
        </div>

        <div class="pt-4 border-t border-gray-100">
          <h3 class="text-sm font-semibold text-gray-900 mb-3">Contact</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-xs text-gray-500">Nom du contact</span>
              <input
                class="rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-secondary"
                [(ngModel)]="s.contactName"
              >
            </label>
            <label class="flex flex-col gap-1">
              <span class="text-xs text-gray-500">Email du contact</span>
              <input
                class="rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-secondary"
                [(ngModel)]="s.contactMail"
              >
            </label>
          </div>
          <div class="pt-4 flex w-full justify-stretch sm:justify-end">
            <button
              class="w-full sm:w-auto rounded-lg bg-secondary px-4 py-2 text-sm font-medium text-white hover:bg-secondary-hover cursor-pointer"
              (click)="saveContact()"
            >
              Enregistrer le contact
            </button>
          </div>
        </div>
      </article>

      @if (!executiveSubscriptionState.isFreeExecutive()) {
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-5 shadow-sm">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">notifications</span>
          <h2 class="font-semibold text-gray-900">Notifications</h2>
        </div>
        <div class="space-y-3">
          <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
            <span class="text-sm text-gray-700">Alertes légales</span>
            <button
              type="button"
              (click)="toggleSetting('legalAlertsEnabled')"
              [attr.aria-pressed]="s.legalAlertsEnabled"
              class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer"
              [class.bg-secondary]="s.legalAlertsEnabled"
              [class.bg-gray-300]="!s.legalAlertsEnabled"
            >
              <span class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform"
                    [class.translate-x-5]="s.legalAlertsEnabled"
                    [class.translate-x-1]="!s.legalAlertsEnabled"></span>
            </button>
          </label>
          <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
            <span class="text-sm text-gray-700">Alertes expiration attestations</span>
            <button
              type="button"
              (click)="toggleSetting('expiryAlertsEnabled')"
              [attr.aria-pressed]="s.expiryAlertsEnabled"
              class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer"
              [class.bg-secondary]="s.expiryAlertsEnabled"
              [class.bg-gray-300]="!s.expiryAlertsEnabled"
            >
              <span class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform"
                    [class.translate-x-5]="s.expiryAlertsEnabled"
                    [class.translate-x-1]="!s.expiryAlertsEnabled"></span>
            </button>
          </label>
          <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
            <span class="text-sm text-gray-700">Notifications email</span>
            <button
              type="button"
              (click)="toggleSetting('emailNotificationsEnabled')"
              [attr.aria-pressed]="s.emailNotificationsEnabled"
              class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer"
              [class.bg-secondary]="s.emailNotificationsEnabled"
              [class.bg-gray-300]="!s.emailNotificationsEnabled"
            >
              <span class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform"
                    [class.translate-x-5]="s.emailNotificationsEnabled"
                    [class.translate-x-1]="!s.emailNotificationsEnabled"></span>
            </button>
          </label>
          <div class="pt-2 border-t border-gray-100">
            <p class="text-xs text-gray-500 mb-2">Activer les notifications par entreprise</p>
            <div class="space-y-2">
              @for (entry of s.companyNotifications; track entry.siret) {
                <label class="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2">
                  <span class="text-sm text-gray-700">{{ entry.companyName }}</span>
                  <button
                    type="button"
                    (click)="toggleCompanyNotification(entry.siret)"
                    [attr.aria-pressed]="entry.enabled"
                    class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer"
                    [class.bg-secondary]="entry.enabled"
                    [class.bg-gray-300]="!entry.enabled"
                  >
                    <span class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform"
                          [class.translate-x-5]="entry.enabled"
                          [class.translate-x-1]="!entry.enabled"></span>
                  </button>
                </label>
              }
            </div>
          </div>
        </div>
      </article>
      }

      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-4 shadow-sm">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">shield</span>
          <h2 class="font-semibold text-gray-900">Sécurité</h2>
        </div>
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 rounded-lg border border-gray-100 px-3 py-2">
          <div class="min-w-0">
            <p class="text-sm font-medium text-gray-900">Mot de passe</p>
            <p class="text-xs text-gray-500">Dernière modification : inconnue</p>
          </div>
          <button
            type="button"
            (click)="togglePasswordForm()"
            class="w-full sm:w-auto rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
          >
            Modifier
          </button>
        </div>

        @if (showPasswordForm()) {
          <div class="rounded-lg border border-gray-100 p-3 bg-gray-50 space-y-3">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
              <label class="flex flex-col gap-1">
                <span class="text-xs text-gray-500">Mot de passe actuel</span>
                <input
                  type="password"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-secondary bg-white"
                  [value]="currentPassword()"
                  (input)="currentPassword.set($any($event.target).value)"
                  autocomplete="current-password"
                >
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-xs text-gray-500">Nouveau mot de passe</span>
                <input
                  type="password"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-secondary bg-white"
                  [value]="newPassword()"
                  (input)="newPassword.set($any($event.target).value)"
                  autocomplete="new-password"
                >
              </label>
              <label class="flex flex-col gap-1">
                <span class="text-xs text-gray-500">Confirmer le mot de passe</span>
                <input
                  type="password"
                  class="rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-secondary bg-white"
                  [value]="confirmNewPassword()"
                  (input)="confirmNewPassword.set($any($event.target).value)"
                  autocomplete="new-password"
                >
              </label>
            </div>
            <p class="text-xs text-gray-500">
              Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.
            </p>
            <div class="flex flex-col-reverse sm:flex-row gap-2 justify-stretch sm:justify-end">
              <button
                type="button"
                class="rounded-lg border border-gray-300 px-3 py-2 sm:py-1.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                (click)="togglePasswordForm()"
                [disabled]="changingPassword()"
              >
                Annuler
              </button>
              <button
                type="button"
                class="rounded-lg bg-secondary px-3 py-2 sm:py-1.5 text-sm font-medium text-white hover:bg-secondary-hover disabled:bg-secondary/50 disabled:cursor-not-allowed cursor-pointer"
                [disabled]="!canSubmitPasswordChange() || changingPassword()"
                (click)="savePassword()"
              >
                @if (changingPassword()) { Enregistrement... } @else { Enregistrer le mot de passe }
              </button>
            </div>
          </div>
        }
        @if (!executiveSubscriptionState.isFreeExecutive()) {
        <label class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 rounded-lg border border-gray-100 px-3 py-2">
          <div class="min-w-0">
            <p class="text-sm font-medium text-gray-900">Authentification à deux facteurs</p>
            <p class="text-xs text-gray-500">Ajoutez une couche de sécurité supplémentaire</p>
          </div>
          <button
            type="button"
            disabled
            class="w-full sm:w-auto rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-400 cursor-not-allowed bg-gray-50"
          >
            Bientôt disponible
          </button>
        </label>
        }
      </article>

      @if (!executiveSubscriptionState.isFreeExecutive()) {
      <article class="rounded-xl border border-gray-200 bg-white p-5 space-y-4 shadow-sm">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined text-secondary">language</span>
          <h2 class="font-semibold text-gray-900">Langue & région</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label class="flex flex-col gap-1">
            <span class="text-xs text-gray-500">Langue</span>
            <input
              class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-500 cursor-not-allowed"
              [value]="language()"
              disabled
            >
          </label>
          <label class="flex flex-col gap-1">
            <span class="text-xs text-gray-500">Fuseau horaire</span>
            <input
              class="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-500 cursor-not-allowed"
              [value]="timezone()"
              disabled
            >
          </label>
        </div>
      </article>

      <article class="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div class="flex items-start gap-2 min-w-0">
            <span class="material-symbols-outlined text-secondary shrink-0">key</span>
            <div class="min-w-0">
              <h2 class="font-semibold text-gray-900">API & intégrations</h2>
              <p class="text-xs text-gray-500">Gérez votre clé API Attestio (bientôt disponible)</p>
            </div>
          </div>
          <button
            type="button"
            disabled
            class="w-full sm:w-auto rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-400 cursor-not-allowed bg-gray-50"
          >
            Bientôt disponible
          </button>
        </div>
      </article>
      }
    }
  </div>
</section>
